import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { InsightPassengerAddressModel } from 'src/app/core/models/individual-model';
import { AddressMapperService } from 'src/app/modules/insight-management/insight-management-content/insight-detail/insight-detail-address/shared/address-mapper.service';
import { Select2Data } from 'src/app/shared/ui/forms/inputs/oops-select2';
import { InvoiceIndividualDetailModel } from '../../../../../../../core/models/individual-model';
import { InvoiceIndividualDetailMapperService } from './invoice-individual-detail-mapper.service';
import { select2UseAddress } from 'src/app/core/components/address/shared/address-configuration';
import { RouteDataService } from 'src/app/core/components/address/shared/route-data-service';
import { select2Country, select2LocationOption, select2WithoutSearchOption } from '../../shared/payment-document-invoice.constants';
import { AddressTypeReferenceService, CountryReferenceService, LocationReferenceService } from 'src/app/core/services/system-services';
import { BehaviorSubject } from 'rxjs';
import { AddressTypeReferenceModel, CountryReferenceModel } from 'src/app/core/models/reference-model/reference-general-model';
import { NgForm } from '@angular/forms';
import { LocationReference } from 'src/app/core/models/location-model';
import { UiHelperService } from 'src/app/core/utils/ui-helper.service';
@Component({
    selector: 'op-invoice-individual-detail',
    templateUrl: './invoice-individual-detail.component.html',
    providers: [
        AddressMapperService,
        InvoiceIndividualDetailMapperService,
        RouteDataService
    ]
})
export class InvoiceIndividualDetailComponent implements OnInit {
    readonly ERROR_ADDRESS_REQUIRED = 'Address is required.';
    readonly ERROR_ADDRESS_TYPE_REQUIRED = 'Address Type is required.';
    readonly ERROR_ADDRESS_LINE1_REQUIRED = 'Address Line 1 is required.';
    readonly ERROR_CITY_REQUIRED = 'City is required.';
    readonly ERROR_POSTEL_REQUIRED = 'Postal Code is required';
    readonly ERROR_COUNTRY_REQUIRED = 'Country is required';
    public detailFocused = false;
    public addressFocused = false;
    public individualDetailView: InvoiceIndividualDetailModel;
    public locationSavedData: Select2Data[] = [];
    public useAddress: InsightPassengerAddressModel[] = [];
    public select2Option: any;
    public select2CountryOption: any;
    public select2LocationOption: any;
    public select2UseAddressOption = select2UseAddress;
    public disabledDetail: boolean[];
    public disabledAddress: boolean[];
    public addressTypeReferences$ = new BehaviorSubject<AddressTypeReferenceModel[]>(null);
    public originalIndividualDetail: InvoiceIndividualDetailModel;
    public insightAddresses: InsightPassengerAddressModel[];

    public newAddressFlag: boolean = false;
    private _countryReferences: CountryReferenceModel[];
    private _locationReferences: LocationReference[];
    private _defaultCountry: Select2Data;
    private _defaultLocation: Select2Data;

    get address() {
        return this.individualDetailView.InvoiceAddress;
    }

    get defaultDetailView(): InvoiceIndividualDetailModel {
        return {
            individualId: null,
            titleCode: null,
            firstName: null,
            lastName: null,
            languageCode: null,
            phoneTypeCode: null,
            phonePrefix: null,
            phoneNumber: null,
            mailAddress: null,
            InvoiceAddress: this.defaultAddressView
        }
    }

    get defaultAddressView(): InsightPassengerAddressModel {
        return {
            addressId: null,
            individualId: null,
            useAddressId: null,
            countryCode: null,
            addressLine1: null,
            addressLine2: null,
            postalCode: null,
            state: null,
            province: null,
            city: null,
            primaryFlag: false,
            locationId: null,
            addressTypeCode: null,
            addressTypeName: null,
            countryName: null,
            locationName: null,
            organisationId: null
        };
    }

    get disabledInputs(): boolean[] {
        let result = new Array<boolean>();
        if (!this.disabledDetail) {
            return result;
        }
        return this.disabledDetail;
    }

    get disabledAddressInputs(): boolean[] {
        let result = new Array<boolean>();
        if (!this.disabledAddress) {
            return result;
        }
        return this.disabledAddress;
    }

    get countryValid(): boolean {
        return !this.address?.countryCode
    }

    public paymentAddressRequired: boolean = false;

    @Output() onClearIndividual = new EventEmitter();
    @Output() onNew = new EventEmitter();

    @ViewChild('individualDetailForm') individualDetailForm: NgForm;
    @ViewChild('addressDetailForm') addressDetailForm: NgForm;
    @ViewChild('addressRef') addressRef: ElementRef;

    constructor(private addressMapperService: AddressMapperService,
        private addressTypeService: AddressTypeReferenceService,
        private countryReferenceService: CountryReferenceService,
        private locationReferenceService: LocationReferenceService,
        private changeDetector: ChangeDetectorRef,
        private uiHelperService: UiHelperService) {
        this.setSelect2Option();
        this.getAddressTypeReferences();
        this.select2LocationOption.minimumInputLength = 0;
        this.select2LocationOption.ajax = this.getLocationReferenceAjax();
        this.select2CountryOption.ajax = this.getCountryReferenceAjax();
    }

    ngOnInit(): void {
        this.getCountryReferences();
        this.getLocationReferences();
        this.individualDetailView = this.defaultDetailView;
    }

    public setSelect2Option() {
        this.select2Option = select2WithoutSearchOption;
        this.select2CountryOption = select2Country;
        this.select2LocationOption = select2LocationOption;
    }

    private getCountryReferences() {
        this.countryReferenceService.getCountryReference()
            .subscribe(
                (response) => {
                    this._countryReferences = response
                        ?.sort((a, b) => a.countryName.localeCompare(b.countryName));
                }
            )
    }

    private getLocationReferences() {
        this.locationReferenceService.getLocationReferenceList()
            .subscribe(
                (response) => {
                    this._locationReferences = response
                        ?.sort((a, b) => a.locationName.localeCompare(b.locationName));
                }
            )
    }

    private getLocationSave(address: InsightPassengerAddressModel) {
        if (!address?.locationId) {
            return;
        }
        this.locationSavedData = this.addressMapperService.getLocationSave(address.locationId, address.locationName)
    }

    public onClearDetail() {
        this.individualDetailView = this.defaultDetailView;
    }

    public getUseAddress(addresses: InsightPassengerAddressModel[], individual: InvoiceIndividualDetailModel, individualAddressId: string) {
        if ((!addresses || !individual?.InvoiceAddress?.useAddressId) && !individualAddressId) {
            return;
        }
        let addressId = individualAddressId;
        if (!addressId) {
            addressId = individual.InvoiceAddress.useAddressId;
        }
        let address = addresses.find(address => address.addressId === addressId);
        if (address) {
           this.individualDetailView.InvoiceAddress = address;
        }
        this.getLocationSave(address);
        individual.InvoiceAddress = {
            addressId: individual.InvoiceAddress.addressId,
            addressLine1: address.addressLine1,
            addressLine2: address.addressLine2,
            countryCode: address.countryCode,
            countryName: address.countryName,
            postalCode: address.postalCode,
            state: address.state,
            province: address.province,
            city: address.city,
            locationId: address.locationId,
            locationName: address.locationName,
            addressTypeCode: address.addressTypeCode,
            addressTypeName: address.addressTypeName,
            primaryFlag: individual.InvoiceAddress.primaryFlag,
            individualId: individual.InvoiceAddress.individualId,
            useAddressId: individual.InvoiceAddress.useAddressId,
            organisationId: individual.InvoiceAddress.organisationId
        }

        this.useAddress.push(address);
    }

    public setContactDetailToIndividual(individual: InvoiceIndividualDetailModel) {
        individual.InvoiceAddress ??= this.defaultAddressView;
        this.individualDetailView = individual;
        this.originalIndividualDetail = individual;
        this.setDisableDetailFields(individual);
        this.changeDetector.detectChanges();
    }

    public setDisableDetailFields(individual: InvoiceIndividualDetailModel) {
        this.disabledAddress = this.getDisabledInputs(individual.InvoiceAddress);
    }

    private getAddressTypeReferences() {
        this.addressTypeService.getAddressTypeReferences()
            .subscribe(
                (response) => {
                    this.addressTypeReferences$.next(response);
                }
            )
    }

    public getDisabledInputs(individualDetailView: any): boolean[] {
        let result = new Array<boolean>();

        if (!individualDetailView) {
            return result;
        }

        for (let key of Object.keys(individualDetailView)) {
            result[key] = false;
        }

        for (let key of Object.keys(individualDetailView)) {
            if (individualDetailView[key]) {
                result[key] = true;
            }
        }
        return result;
    }

    public clickNew() {
        this.individualDetailView = this.defaultDetailView;
        this.onNew.emit();
    }

    public clickRefresh() {
        this.individualDetailView = this.originalIndividualDetail;
    }

    public clickNewAddress() {
        this.individualDetailView.InvoiceAddress = this.defaultAddressView;
        this.disabledAddress = [];
        this.newAddressFlag = true;
    }

    onPresetSelected(item: InsightPassengerAddressModel) {
        if (!item) return;
        let useAddress = this.insightAddresses.find(item => item.addressId == item.useAddressId);
        this.getLocationSave(item);
        this.individualDetailView.InvoiceAddress = {
            addressId: item.addressId,
            addressLine1: useAddress?.addressLine1.trim() ?? item.addressLine1.trim(),
            addressLine2: useAddress?.addressLine2 ?? item.addressLine2.trim(),
            countryCode: useAddress?.countryCode.trim() ?? item.countryCode.trim(),
            countryName: useAddress?.countryName.trim() ?? item.countryName.trim(),
            postalCode: useAddress?.postalCode?.trim() ?? item.postalCode.trim(),
            state: useAddress?.state.trim() ?? item.state.trim(),
            province: useAddress?.province.trim() ?? item.province.trim(),
            city: useAddress?.city ?? item.city.trim(),
            locationId: useAddress?.locationId ?? item.locationId,
            locationName: useAddress?.locationName ?? item.locationName,
            addressTypeCode: item.addressTypeCode,
            addressTypeName: item.addressTypeName,
            primaryFlag: null,
            individualId: this.individualDetailView.individualId,
            useAddressId: item.useAddressId,
            organisationId: null
        }
        this.setDisableDetailFields(this.individualDetailView);
    }

    public validatePaymentAddress() {
        return this.addressDetailForm.valid;
    }

    get displayNewAddressType() {
        if (!this.newAddressFlag) {
            return !this.address?.addressId && this.insightAddresses?.length == 0
        }
        return this.newAddressFlag;
    }

    public getIndividualDetailAndAddress(): InvoiceIndividualDetailModel {
        if (!this.address?.addressId) return this.individualDetailView;
        let addressRef = this.insightAddresses?.find(item => item.addressId == this.address?.addressId);
        this.address.useAddressId = addressRef?.useAddressId;
        return this.individualDetailView;
    }

    public getCountryReference(countryCode: string): Select2Data {
        if (!countryCode) return null;
        if (this._defaultCountry?.id == countryCode) return this._defaultCountry;
        this._defaultCountry = this._countryReferences
            ?.filter(x => x.countryCode == countryCode)
            ?.map(x => new Select2Data(x.countryCode, x.countryName))
            ?.[0];
        return this._defaultCountry;
    }

    public getLocationReference(locationId: string): Select2Data {
        if (!locationId) return null;
        if (this._defaultLocation?.id == locationId) return this._defaultLocation;
        this._defaultLocation = this._locationReferences
            ?.filter(x => x.locationId == locationId)
            ?.map(x => new Select2Data(x.locationId, x.locationName))
            ?.[0];
        return this._defaultLocation;
    }

    private getCountryReferenceAjax() {
        const populateData = (searchTerms: string) => {
            const locationId = this.individualDetailView.InvoiceAddress?.locationId;
            const location = this._locationReferences?.find(l => l.locationId == locationId);
            return this._countryReferences
                ?.filter(x => x.countryCode.toLowerCase().includes(searchTerms.toLowerCase()) ||
                    x.countryName.toLowerCase().includes(searchTerms.toLowerCase()))
                ?.filter(x => !location || (location.countryCode == x.countryCode))
                ?.map(x => new Select2Data(x.countryCode, x.countryName))
        }
        return {
            delay: 200,
            transport: (params, success) => {
                const searchTerm = params?.data?.term ?? '';
                success({
                    results: populateData(searchTerm)
                })
            }
        }
    }

    private getLocationReferenceAjax() {
        const populateData = (locationReferences: LocationReference[], searchTerms: string) => {
            const locationReferencesSorted = locationReferences
                ?.filter(l => l.locationName.toLowerCase().includes(searchTerms) ||
                    l.locationCode.toLowerCase().includes(searchTerms));
            return locationReferencesSorted
                ?.map(x => new Select2Data(x.locationId, x.locationName));;
        }
        return {
            delay: 200,
            transport: (params, success) => {
                const countryCode = this.individualDetailView.InvoiceAddress?.countryCode;
                const searchTerms = params.data?.term?.toLowerCase() ?? '';
                if (countryCode) {
                    this.locationReferenceService.getLocationReferenceSearch({
                        statusCode: 'A',
                        countryCode: countryCode,
                        locationNameOrCode: searchTerms
                    }).subscribe(
                        responses => {
                            const sorted = responses
                                ?.sort((a, b) => a.locationName.localeCompare(b.locationName))
                            success({
                                results: sorted
                                    ?.map(x => new Select2Data(x.id, x.locationName))
                            })
                        }
                    )
                } else {
                    success({
                        results: populateData(this._locationReferences, searchTerms)
                    })
                }
            }
        }
    }

    public getErrorMessagePaymentAddress(): string {
        if (this.addressEmpty()) {
            return this.ERROR_ADDRESS_REQUIRED;
        } else if (!this.address?.addressTypeCode) {
            return this.ERROR_ADDRESS_TYPE_REQUIRED;
        } else if (!this.address?.addressLine1) {
            return this.ERROR_ADDRESS_LINE1_REQUIRED;
        } else if (!this.address?.city) {
            return this.ERROR_CITY_REQUIRED;
        } else if (!this.address?.postalCode) {
            return this.ERROR_POSTEL_REQUIRED;
        } else if (this.countryValid) {
            return this.ERROR_COUNTRY_REQUIRED;
        }
    }

    clickClear() {
        this.onClearIndividual.emit();
    }

    public focusAddress() {
        if (this.getErrorMessagePaymentAddress()) {
            this.uiHelperService.moveScrollPosition(this.addressRef, 350);
        }
    }

    private addressEmpty(): boolean {
        if (!this.address?.addressTypeCode &&
            !this.address?.addressLine1 &&
            !this.address?.city &&
            !this.address?.postalCode &&
            !this.address?.countryCode) {
            return true;
        }
        return false;
    }
}
